
  import {
    Component,
    Vue
  } from 'vue-property-decorator';
  import {
    productRank,
    providerIndexStatistics,
    getProductSalesStatistics,
    productSellStatisList
  } from '@/api/statistic';
  import {
    RoleData,
    maxspecifications
  } from '@/utils/config'
  import {
    getUserInfo
  } from '@/utils/storage'
  import {
    getSearchDate,
    nextDay
  } from "@/utils"
  import {
    orderSupportlist
  } from "@/api/after_sales"
  import {
    productscheduleProductList,
    getProviderSalesOrderList
  } from "@/api/order"
  @Component({
    name: 'home-index'
  })
  export default class HomeIndex extends Vue {
    private defaultAvatar = 'https://cdn2024.routuan.com/routuanapp/default-avatar.png'

    private todayData: any = {};
    private productRankList: any = [];
    private roles = RoleData;
    private activeIndex = 0;

    private homeData: any = {};
    private orderInfo: any = {};
    private monthlySalesList:any = []

    private scheduleList:any = []
    private orderList:any = []
    private ProductCountDisplay = 0
    
		//最多添加规格数
		private specificationsNum = maxspecifications

    private mounted() {
      // this.getProductRank();
      // this.getSaleList();
      this.getHomeData();
      this.getScheduleList()
      this.getOrderList()
      this.getproductSellStatisList()
    }

    private get userInfo() {
      return getUserInfo();
    }



    //订单  待发货商品（近90天下单）
    private async getOrderList(){
      try{
        let data: any = {
          SendState:0,
          StartTime:nextDay(getSearchDate(0,false)[0],-90),
          EndTime:nextDay(getSearchDate(0,false)[0],1),
        }
      let res = await getProviderSalesOrderList(data)
      if(res.IsSuccess){
        this.orderList = res.Result.List
        this.ProductCountDisplay = res.Result.Total.ProductCountDisplay
      }
      }finally{
        //
      }
    }
    //审核排期数据
    private async getScheduleList(){
      try{
        let data = {
          StartTime:nextDay(getSearchDate(0,false)[0],-360),
          EndTime:nextDay(getSearchDate(0,false)[0],1),
          Skip:0,
          Take:9999
        }
        let res = await productscheduleProductList(data)
        if(res.IsSuccess){
          this.scheduleList = res.Result.Results
        }
      }finally{
        //
      }
    }
    private toPage(type,obj){
      let data:any = {
        path:'',
      }
      if(type==1){
        data = {
          name:'auditScheduleShop',
          params:{
            name:''
          }
        }
      }else if(type==2){
        data = {
          name:'Product_Sales',
          params:{
            
          }
        }
      }else if(type==3){
        data = {
          name:'Product_Sales',
          params:{
            time:[getSearchDate(1)[1],getSearchDate(1)[1]].join('/')
          }
        }
      }else if(type==4){
        data = {
          name:'Order_List',
          params:{
            time:[nextDay(getSearchDate(1)[1],-30),getSearchDate(1)[1]].join('/')
          }
        }
      }else if(type==5){
        data = {
          name:'After_List',
          params:{
            time:[getSearchDate(1)[1],getSearchDate(1)[1]].join('/')
          }
        }
      }else if(type==6){
        data = {
          name:'Order_List',
          query:{}
        }
      }else if(type==7){
        data = {
          name:'auditScheduleShop',
          params:{
            name:encodeURI(obj.ProductName)
          }
        }
      }
        // console.log(data)
        // return 
      this.$router.push(data)
    }
    private changeActive(index: number) {
      // if (this.activeIndex === index) return;
      // this.activeIndex = index;
      // this.getSaleList();
      this.$router.push({
        path:'/order/list'
      })
    }

    /**
     * 获取首页数据
     */
    private async getHomeData() {
      try {
        const res: any = await providerIndexStatistics({});
        if(res.IsSuccess){
          this.homeData = {
            ...res.Result,
            afterSale:0,
          }
          this.homeData.WaitSendOrderList = this.homeData.WaitSendOrderList.map(v=>{
            let list:any = []
            for(let i = 0;i<this.specificationsNum;i++){
              let key = 'SpecValue'+(i==0?'':i+1)
              if(v[key]){
                list.push(v[key])
              }
            }
            v.SpecValueDisPlay = list.join(';')
            // console.log(v.SpecValueDisPlay)
            return v
          })
        }
        const afterSale = await orderSupportlist({
          Skip:0,
          Take:99999,
          StartTime:getSearchDate(1)[1],
          EndTime:nextDay(getSearchDate(1)[1],1)
        })
        if(afterSale.IsSuccess){
          this.homeData.afterSale = afterSale.Result.Total
        }
        // console.log(res.Result)
        // this.productRankList = res.Result.HomeProductSellStatisList
      } catch (err) {
        console.log(err);
      }
    }

    private async getproductSellStatisList(){
      // console.log(getSearchDate(1))
      try{
        let res:any = await productSellStatisList({})
        if(res.IsSuccess){

          this.monthlySalesList = res.Result||[]
        }
      }finally{
        //
      }
    }

    /**
     * 获取商品排行
     */
    private async getProductRank() {
      let today = parseInt(new Date(new Date().toLocaleDateString()).getTime() / 1000 + '')
      try {
        const res: any = await productRank({
          time: today,
          page_no: 1,
          page_size: 10
        });
        this.productRankList = res.info || [];
      } catch (e) {
        console.log('productRank ===>', e)
      }
    }

    /**
     * 商品销量统计
     */
    private async getSaleList() {
      try {

        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth()+1;

        const res: any = await getProductSalesStatistics({
          Skip: 0,
          Take: 5,
          StartTime: year+'-'+month+'-1 00:00:00',
          EndTime: year+'-'+(month+1)+'-1 00:00:00',
        })
        this.productRankList = res.Result.Results;
      } catch (err) {
        console.log(err);
      }
    }

    private toOrder() {
      this.$router.push({
        name: 'Order_List'
      })
    }
  }
